export default "__VITE_ASSET__CJtY5G9___"